// @flow
import download from "downloadjs";
import Properties from "../../../Properties";
import { getInit, postInit, graphQLInit, putInit } from "../../global/types/constants";
import type { DispatchType, StateType } from "../../global/types/redux";
import { LicenceNode, FacebaseNode } from "../types/GraphQlNodes";
import { updateCompanyLicence } from "./companyActions";
import { apiFailCallbackHandle } from "../containers/ErrosDisplay";
import {
  SET_AUTH, SET_LOGINS, SET_FETCHING_AUTH, SET_USER_GRAPHQL, UPDATE_USER, UPDATE_USER_LICENCE, ADD_TAB, SET_STEP
} from "../../global/actions/actionNames";

const root = Properties.api_root;

const setFetchingAuthentication = (status = true) => ({
  type: SET_FETCHING_AUTH,
  status
});

const setAuth = (authenticated: boolean) => ({
  type: SET_AUTH,
  authenticated
});

const setLogins = (logins: Object) => ({
  type: SET_LOGINS,
  logins
});

const setUserGraphQl = (user: Object) => ({
  type: SET_USER_GRAPHQL,
  user
});

export const fetchUserGraphQl = (): * => (dispatch: DispatchType): * => {
  dispatch(setFetchingAuthentication(false));

  const graphQl = `
  {
    firstName
    lastName
    email
    groups
    auditCreationDate
    lastLoggedIn
    company {
      id
      uuid
      name
      companyType
      authorisedReseller
    }
    defaultFacebase {
      ${FacebaseNode}
    }
    facebases {
      ${FacebaseNode}
    }
    licences {
      edges {
        node {
          ${LicenceNode}
        }
      }
    }
  }
  `;
  return fetch(`${root}/api/v2/graphql/user`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch(setUserGraphQl(json.data));
    });
};

export const fetchAuthentication = (shouldSetAuth?: boolean = true, callback?: Function = null): * => (dispatch: DispatchType): * => {
  dispatch(setFetchingAuthentication());
  return fetch(`${root}/api/v2/users/authenticated`, getInit)
    .then(response => response.json())
    .then(json => {
      if(shouldSetAuth){
        dispatch(setAuth(json.authenticated));
        if (json.authenticated) {
          dispatch(fetchUserGraphQl());
        }
      }

      callback && callback(json.authenticated);
    });
};

export const logout = (callback: () => void) => {
  fetch(`${root}/api/v2/user/logout`, postInit())
    .then(resp => callback());
};

export function assignDevice(deviceid: string, licenceid: string, licenceuuid: string, doneBack: Function, failBack: Function) {
  let formData = new FormData();
  formData.append("assign_devices", deviceid);
  return (dispatch: any) => {
    fetch(root + "/api/v2/licences/" + licenceuuid, putInit(formData))
      .then(response => response.json())
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "licence"));
        }
        else {
          dispatch(updateUserLicence(licenceid));
          dispatch(updateCompanyLicence(licenceid));
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message, "licence"));
      });
  };
}

export function unAssignDevice(deviceid: string, licenceid: string, licenceuuid: string, doneBack: Function, failBack: Function) {
  let formData = new FormData();
  formData.append("unassign_devices", deviceid);
  return (dispatch: any) => {
    fetch(root + "/api/v2/licences/" + licenceuuid, putInit(formData))
      .then(response => response.json())
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "licence"));
        }
        else {
          dispatch(updateUserLicence(licenceid));
          dispatch(updateCompanyLicence(licenceid));
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message, "licence"));
      });
  };
}

export function downloadLicence(host_id: string, doneCall: Function, failBack: Function) {
  return (dispatch: any) => {
    fetch(root + "/api/v2/devices/" + host_id + "/licence", getInit)
      .then(function (response: Response) {
        if (response.ok) {
          return response.text();
        }
        else {
          return response.json();
        }
      })
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "licence"));
          return Promise.reject();
        }
        else {
          return json;
        }
      })
      .then((textRes: string): void => {
        download(textRes, `${host_id}.imlic`, "text/csv");
        doneCall && doneCall();
      });
  };
}

export const updateUserLicence = (licenceId: string) => (dispatch: any) => {
  const graphQl = `
  {
    node(id: "${licenceId}") {
      ... on Licence {
        ${LicenceNode}
      }
    }
  }
  `;
  return fetch(`${root}/api/v2/graphql/user`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({ type: UPDATE_USER_LICENCE, data: json.data.node });
    });
};

export const addCompanyTab = (tab) => ({
  type: ADD_TAB,
  tab
});

export const setCompanyStep = (step) => ({
  type: SET_STEP,
  step
});


export function updateUser(firstName: string, lastName: string, facebaseUid: string, doneBack: Function, failBack: Function): * {
  let formData = new FormData();
  formData.append("first_name", firstName);
  formData.append("last_name", lastName);
  formData.append("facebase_uid", facebaseUid);
  return (dispatch: DispatchType, getState: StateType) => {
    fetch(root + "/api/v2/user", putInit(formData))
      .then(response => response.json())
      .then(function (json: JSON) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "facebase"));
        }
        else {
          const user = getState().v3account.user;

          if(user.firstName !== firstName){
            dispatch({ type: UPDATE_USER, field: "firstName", value: firstName });
          }
          if(user.lastName !== lastName){
            dispatch({ type: UPDATE_USER, field: "lastName", value: lastName });
          }
          if(user.defaultFacebase.uuid !== facebaseUid){
            let index = user.facebases.findIndex(x => x.uuid === facebaseUid);
            let facebase = user.facebases[index];
            dispatch({ type: UPDATE_USER, field: "defaultFacebase", value: facebase });
          }
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message, "user"));
      });
  };
}
